function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31 62C22.7782 62 14.8934 58.734 9.07983 52.9202C3.26605 47.1068 0 39.2216 0 31C0 22.7784 3.26605 14.8934 9.07983 9.07983C14.8932 3.26605 22.7784 0 31 0C39.2216 0 47.1066 3.26605 52.9202 9.07983C58.734 14.8932 62 22.7784 62 31C62 36.4413 60.5676 41.7873 57.8469 46.4999C55.1258 51.2125 51.2127 55.1256 46.4999 57.8469C41.7873 60.5676 36.4413 62 31 62ZM31 3.87542C23.8062 3.87542 16.9073 6.73315 11.82 11.82C6.73326 16.9072 3.87542 23.8069 3.87542 31C3.87542 38.1931 6.73315 45.0927 11.82 50.18C16.9072 55.2667 23.8069 58.1246 31 58.1246C38.1931 58.1246 45.0927 55.2668 50.18 50.18C55.2667 45.0928 58.1246 38.1931 58.1246 31C58.1246 26.2384 56.8713 21.5612 54.4905 17.4376C52.1097 13.314 48.6858 9.89004 44.5622 7.50925C40.4385 5.12847 35.7613 3.87519 30.9998 3.87519L31 3.87542Z",
  fill: "#54B230"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.1872 44.6251C24.6721 44.6281 24.1774 44.4257 23.8115 44.0633L14.124 34.3759L16.856 31.6439L25.1872 39.9556L45.1234 19.9995L47.8553 22.7315L26.543 44.0438C26.1853 44.4088 25.6979 44.6177 25.1867 44.6251L25.1872 44.6251Z",
  fill: "#54B230"
});

var SvgSuccess = function SvgSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Success.b8ec2a74.svg";
export { ForwardRef as ReactComponent };